import React from 'react';
import { FaFacebookF, FaTwitter, FaYoutube, FaLinkedinIn } from 'react-icons/fa';
import logo from '../asset/Images/logo.png'
const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Logo and Description */}
        <div className="footer-section">
          <div className="footer-logo w-100">
            <img
              src={logo}
              alt="Hongkong Logo"
              className='w-50'
            />
          </div>
          {/* <div className="footer-socials">
            <FaFacebookF />
            <FaTwitter />
            <FaYoutube />
            <FaLinkedinIn />
          </div> */}
        </div>

        {/* Opening Times */}
        <div className="footer-section">
          <h4>Opening Times</h4>
          <ul className="opening-times">
          <li><strong>Mon-Thur: </strong>  11:00am - 9:30pm</li>
              <li><strong>Fri-Sat:</strong> 9:30am - 10:00pm</li>
              <li><strong>Sunday:</strong> 9:30am - 9:30pm</li>
          </ul>
        </div>

        {/* Contact Information */}
        <div className="footer-section">
          <h4>Contact Us</h4>
          <p>Hongkong Noodles</p>
          <p>815 E 78th St, Minneapolis, MN 55420</p>
          <p>763-600-6270</p>
          <p>Powered by Hongkong Noodles</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
